module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/114-british-virgin-islands-989d949e88e4ae1467a1e29cea51f26a.svg";